/**
 * Main-screen auth float — login ↔ register crossfade tuning (`formMotionVariant === 'mainScreenV3'`).
 * Used by: `MainScreenAuthForms` only.
 */
import { StyleSheet } from 'react-native';
import { Extrapolation, interpolate } from 'react-native-reanimated';
import { appTheme } from '../../../shared/theme';

export const mainScreenV3AuthFormShell = StyleSheet.create({
  outer: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    paddingHorizontal: appTheme.spacing.sm,
    paddingBottom: appTheme.spacing.xs,
  },
});

export function mainScreenV3LoginLayerAt(t: number) {
  'worklet';
  return {
    opacity: interpolate(t, [0, 0.32, 0.68, 1], [1, 0.92, 0.38, 0], Extrapolation.CLAMP),
    transform: [
      { translateY: interpolate(t, [0, 1], [0, -7], Extrapolation.CLAMP) },
      { scale: interpolate(t, [0, 1], [1, 0.989], Extrapolation.CLAMP) },
    ],
  };
}

export function mainScreenV3RegisterLayerAt(t: number) {
  'worklet';
  return {
    opacity: interpolate(t, [0, 0.2, 0.58, 1], [0, 0.18, 0.88, 1], Extrapolation.CLAMP),
    transform: [
      { translateY: interpolate(t, [0, 1], [14, 0], Extrapolation.CLAMP) },
      { scale: interpolate(t, [0, 1], [0.986, 1], Extrapolation.CLAMP) },
    ],
  };
}

export const MAIN_SCREEN_V3_FORM_TRANSFORM_ORIGIN = '50% 12%' as const;
